import { randomNumber } from '../../../../utilities'
import { MedicalConsultConstants } from './medicalConsult.constants'
import { IMedicalConsultAction, IMedicalConsultState } from './medicalConsult.types'

export const initialMedicalConsultState: IMedicalConsultState = {
  physician: null,
  otherPhysician: '',
  method: null,
  facility: null,
  assessedBy: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Medical Consult',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  medicalConsultDefaults: null,
  nemsisCode: null,
}

export function medicalConsultReducer(
  state: IMedicalConsultState = initialMedicalConsultState,
  action: IMedicalConsultAction
): IMedicalConsultState {
  switch (action.type) {
    case MedicalConsultConstants.SET_PHYSICIAN:
      return { ...state, physician: action.physician }
    case MedicalConsultConstants.SET_OTHER_PHYSICIAN:
      return { ...state, otherPhysician: action.otherPhysician }
    case MedicalConsultConstants.SET_METHOD:
      return { ...state, method: action.method }
    case MedicalConsultConstants.SET_FACILITY:
      return { ...state, facility: action.facility }
    case MedicalConsultConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case MedicalConsultConstants.SET_DATE:
      return { ...state, date: action.date }
    case MedicalConsultConstants.SET_TIME:
      return { ...state, time: action.time }
    case MedicalConsultConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case MedicalConsultConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case MedicalConsultConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case MedicalConsultConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case MedicalConsultConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case MedicalConsultConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case MedicalConsultConstants.SET_STATE:
      return { ...action.medicalConsultState, updateInputRows: true }
    case MedicalConsultConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case MedicalConsultConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case MedicalConsultConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case MedicalConsultConstants.SET_MEDICAL_CONSULT_DEFAULTS:
      return { ...state, medicalConsultDefaults: action.medicalConsultDefaults }
    case MedicalConsultConstants.RESET_STATE:
      return {
        physician: null,
        otherPhysician: '',
        method: null,
        facility: null,
        assessedBy: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Medical Consult',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        medicalConsultDefaults: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
